module.exports = __webpack_public_path__ + "img/member_trading_record_icon_ycq.31267750.png";